import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import ReduxFileWidget from '../../../shared/redux-file-widget';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const Subscript = styled.a`
  cursor: pointer;
  display: block;
  font-size: 14px;
  margin: 0;
  padding-top: 1.5rem;
  text-align: center;
  text-decoration: underline;
  width: 100%;
`;

const mapStateToProps = state => ({
  formData: state.formData,
  mainState: state,
});

const HomeownerStep13 = ({ incrementStep, decrementStep, setFormData, formData, mainState }) => {
  const validated = formData.proofOfPurchaseFiles;

  const onChangeUpload = files => {
    setFormData({ proofOfPurchaseFiles: files });
  };

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 14 - please upload your proof of purchase"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>How would you like to be contacted?</BackText>
      </BackWrapper>
      <IntroMessage>Thanks for that!</IntroMessage>
      <Header>Please upload your proof of purchase.</Header>
      <IntroMessage>
        This could be an invoice, a receipt, etc. - something that shows the Owens Corning products that were purchased.
      </IntroMessage>
      <InputWrapper>
        <ReduxFileWidget onChange={onChangeUpload} fileUploadState={mainState.appData?.fileUploadState} />
      </InputWrapper>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 14 - please upload your proof of purchase"
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
      <Subscript
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 14 - skip this step for now"
        onClick={incrementStep}
      >
        Skip this step for now
      </Subscript>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeownerStep13);
